/**
 * Loader
 */

require("./adapter")

// #if process.env.TIER === 'premium'
if (pmw.canLoadPremiumFeatures()) {
	require("./functions_premium")
	require("./event_listeners_premium")
}
// #endif

